import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth-service';

export const beforeLoginGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  //  If user is logged in → redirect to landing/dashboard
  if (auth.alreadyLoggedIn()) {
    return router.createUrlTree(['/module-selection']); // or dashboard
  }

  // Otherwise, allow access
  return true;
};
